import { Swords, Target, Shield, Heart, Flame, Hourglass, Dumbbell, Scroll, Trophy, Zap, Crosshair, Sparkles } from "lucide-react";

export const SKILLS = ["strength", "speed", "defense", "stamina", "technique", "precision"];

export const SKILL_META = {
  strength: { label: "Strength", color: "bg-red-700", icon: Swords },
  speed: { label: "Speed", color: "bg-sky-600", icon: Zap },
  defense: { label: "Defense", color: "bg-stone-400", icon: Shield },
  stamina: { label: "Stamina", color: "bg-amber-600", icon: Flame },
  technique: { label: "Technique", color: "bg-violet-600", icon: Sparkles },
  precision: { label: "Precision", color: "bg-emerald-600", icon: Crosshair },
};

export const CLASS_META = {
  Dimachaerus: { icon: Swords, color: "text-red-400", tag: "Dimachaerus" },
  Retiarius: { icon: Target, color: "text-sky-400", tag: "Retiarius" },
  Provocator: { icon: Shield, color: "text-amber-400", tag: "Provocator" },
};

// Gladiator class artwork (uploaded assets)
export const CLASS_IMAGE = {
  Dimachaerus: "/assets/dimacherus.jpg",
  Retiarius: "/assets/retarius.jpg",
  Provocator: "/assets/provocator.jpg",
};
export const LUDUS_IMAGE = "/assets/ludus.jpg";

export const LIFECYCLE = {
  prime: { label: "Prime", cls: "bg-amber-900/40 text-amber-400 border-amber-500/50" },
  veteran: { label: "Veteran", cls: "bg-yellow-900/30 text-yellow-500 border-yellow-600/50" },
  slow_decline: { label: "Slow Decline", cls: "bg-orange-900/40 text-orange-400 border-orange-500/50" },
  rapid_decline: { label: "Rapid Decline", cls: "bg-red-900/40 text-red-400 border-red-500/50" },
  retired: { label: "Retired", cls: "bg-zinc-800 text-zinc-400 border-zinc-600" },
};

export const RARITY = {
  starter:   { label: "Starter",   text: "text-zinc-400",     border: "border-zinc-700",        bg: "bg-zinc-900/40",      dot: "bg-zinc-500" },
  common:    { label: "Common",    text: "text-zinc-300",     border: "border-zinc-600",        bg: "bg-zinc-800/30",      dot: "bg-zinc-400" },
  uncommon:  { label: "Uncommon",  text: "text-emerald-400",  border: "border-emerald-700/50",  bg: "bg-emerald-950/20",   dot: "bg-emerald-400" },
  rare:      { label: "Rare",      text: "text-sky-400",      border: "border-sky-700/50",      bg: "bg-sky-950/20",       dot: "bg-sky-400" },
  elite:     { label: "Elite",     text: "text-violet-400",   border: "border-violet-700/50",   bg: "bg-violet-950/20",    dot: "bg-violet-400" },
  legendary: { label: "Legendary", text: "text-amber-400",    border: "border-amber-600/60",    bg: "bg-amber-950/20",     dot: "bg-amber-400" },
};
export const RARITY_ORDER = ["common", "uncommon", "rare", "elite", "legendary"];

export const TACTICS = [
  { id: "aggressive", label: "Aggressive", desc: "More attack, less defense" },
  { id: "balanced", label: "Balanced", desc: "Even attack and defense" },
  { id: "defensive", label: "Defensive", desc: "More defense, less attack" },
];

export const ICONS = { Heart, Flame, Hourglass, Dumbbell, Scroll, Trophy };

export function classIcon(cls) {
  return (CLASS_META[cls] || {}).icon || Swords;
}
